export const SportNavState = {
  TEASER: 'TEASER',
  LAUNCH: 'LAUNCH',
};
